import { render } from "./daftarRekananMampu.vue?vue&type=template&id=bb88787e"
import script from "./daftarRekananMampu.vue?vue&type=script&lang=js"
export * from "./daftarRekananMampu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__